<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-row>
          <v-col md="6">
            <v-row>
              <v-col md="4">
                <v-text-field
                  v-model="filter.search"
                  placeholder="Поиск по названию"
                  dense
                />
              </v-col>
              <v-col>
                <v-btn @click="modals.new = true">Создать новый шаблон</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="totalTemplates">
          <v-col md="3" v-for="template in templates" :key="template.id">
            <v-card outlined>
              <v-list-item one-line>
                <v-list-item-content>
                  <div class="overline mb-4">Создан: {{ template.created_at | dateTime }}</div>
                  <v-list-item-title class="headline mb-1">{{ template.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-card-text>
                <div class="text--primary">
                  {{ getShortText(template.template) }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="modals.edit = true; selectedTemplate = template">
                  <v-icon left>edit</v-icon> Редактировать
                </v-btn>
                <v-btn
                  color="error"
                  @click="modals.delete = true; selectedTemplate = template"
                >
                  <v-icon left>delete</v-icon> Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col md="12">
            <v-pagination
              v-model="paginator.page"
              :length="paginator.length"
            ></v-pagination>
          </v-col>
        </v-row>
        <div v-else>
          <v-alert outlined type="info" dense class="mt-3">Шаблоны массовой рассылки не созданы</v-alert>
        </div>
      </v-card-text>
    </v-card>
    <EditTemplateModal
      :show.sync="modals.edit"
      :template="selectedTemplate"
      @save="editTemplate(selectedTemplate.id, $event)"
    />
    <NewTemplateModal
      :show.sync="modals.new"
      @save="createNewTemplate($event)"
    />
    <ConfirmModal
      v-if="selectedTemplate"
      title="Внимание"
      :dialog.sync="modals.delete"
      confirmBtnText="Удалить шаблон"
      contentClass="esh-theme adminModal"
      @confirm="deleteTemplate(selectedTemplate)"
    >
      <template #body>
        <v-col>
          Вы действительно хотите удалить шаблон массовой рассылки "{{ selectedTemplate.name }}"?
        </v-col>
      </template>
    </ConfirmModal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { BASE } from '@/config'
import { ConfirmModal } from '@/components/common'
import NewTemplateModal from '@/views/superadmin/notifications/NewTemplateModal'
import EditTemplateModal from '@/views/superadmin/notifications/EditTemplateModal'
import {
  GET_NOTIFICATION_MASS_TEMPLATES,
  DELETE_NOTIFICATION_MASS_TEMPLATE,
  EDIT_NOTIFICATION_MASS_TEMPLATE,
  CREATE_NOTIFICATION_MASS_TEMPLATE
} from '@/requests/superadmin'

export default {
  name: 'TemplatesMassSuperAdmin',
  components: {
    NewTemplateModal,
    EditTemplateModal,
    ConfirmModal
  },
  data() {
    return {
      shortTextLength: 250,
      selectedTemplate: null,
      templates: [],
      totalTemplates: 0,
      offset: 0,
      templatesPerPage: 12,
      filter: {
        search: ''
      },
      paginator: {
        page: 1,
        length: 0
      },
      modals: {
        new: false,
        edit: false,
        delete: false
      }
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    'paginator.page': function(value) {
      this.offset = (value - 1) * this.templatesPerPage
      this.getData()
    },
    totalTemplates: function(value) {
      this.paginator.length = Math.ceil(value / this.templatesPerPage)
    },
    'filter.search': function(state, prevState) {
      if (state.length > prevState.length && state.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchTemplates()
      } else if (state.length < prevState.length && prevState.length >= BASE.SEARCH_MIN_LETTERS) {
        this.searchTemplates()
      }
    }
  },
  methods: {
    getShortText(text) {
      return text.length >= this.shortTextLength ? text.substring(0, this.shortTextLength) + '...' : text
    },
    searchTemplates: debounce(function() {
      this.getDataFromFirstPage()
    }, 300),
    getDataFromFirstPage() {
      this.page = 1
      this.offset = 0
      this.getData()
    },
    async getData() {
      try {
        const { data: { results, count } } = await GET_NOTIFICATION_MASS_TEMPLATES({
          limit: this.templatesPerPage,
          offset: this.offset,
          name: this.filter.search.length >= BASE.SEARCH_MIN_LETTERS ? this.filter.search : ''
        })

        this.totalTemplates = count
        this.templates = results
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить шаблоны массовой рассылки'
        })
      }
    },
    async createNewTemplate(template) {
      try {
        await CREATE_NOTIFICATION_MASS_TEMPLATE(template)
        this.getData()
        this.$notify({
          type: 'success',
          text: `Шаблон "${template.name}" для массовой рассылки создан!`
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось создать новый шаблон массовой рассылки'
        })
      }
    },
    async editTemplate(templateId, data) {
      try {
        await EDIT_NOTIFICATION_MASS_TEMPLATE(templateId, data)
        this.getData()
        this.$notify({
          type: 'success',
          text: `Шаблон "${data.name}" для массовой рассылки изменен!`
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось изменить новый шаблон массовой рассылки'
        })
      }
    },
    async deleteTemplate(template) {
      try {
        await DELETE_NOTIFICATION_MASS_TEMPLATE(template.id)
        this.$notify({
          type: 'success',
          text: `Шаблон массовой рассылки "${template.name}" успешно удален`
        })
        this.getData()
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Не удалось удалить шаблон массовой рассылки'
        })
      }
    }
  }
}
</script>